var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { to } from "@lib/utils";
import * as Sentry from "@sentry/browser";
import { connectWalletMetamask, verifyWalletMetamask } from "./metamask";
import { connectWalletPhantom, verifyWalletPhantom } from "./phantom";
import { WalletExtension } from "./utils";
import { connectWalletWC, verifyWalletWC, } from "./walletconnect";
export * from "./metamask";
export * from "./phantom";
export * from "./utils";
export * from "./walletconnect";
export const connectWallet = (walletProvider) => __awaiter(void 0, void 0, void 0, function* () {
    Sentry.addBreadcrumb({
        category: "connectWallet",
        level: "info",
    });
    Sentry.setTag("wallet.provider", walletProvider);
    let connectWalletResponse;
    let err;
    switch (walletProvider) {
        case WalletExtension.METAMASK:
            ({ err, res: connectWalletResponse } = yield to(connectWalletMetamask()));
            break;
        case WalletExtension.PHANTOM:
            ({ err, res: connectWalletResponse } = yield to(connectWalletPhantom()));
            break;
        case WalletExtension.WALLETCONNECT:
            ({ err, res: connectWalletResponse } = yield to(connectWalletWC()));
            break;
    }
    if (!connectWalletResponse) {
        console.log(err);
        throw err;
    }
    console.log("connectWallet", walletProvider, connectWalletResponse);
    return connectWalletResponse;
});
export const verifyWallet = (walletProvider, connectWalletResponse) => __awaiter(void 0, void 0, void 0, function* () {
    Sentry.addBreadcrumb({
        category: "verifyWallet",
        level: "info",
    });
    Sentry.setTag("wallet.provider", walletProvider);
    let wallet;
    let err;
    switch (walletProvider) {
        case WalletExtension.METAMASK:
            ({ err, res: wallet } = yield to(verifyWalletMetamask(connectWalletResponse)));
            break;
        case WalletExtension.PHANTOM:
            ({ err, res: wallet } = yield to(verifyWalletPhantom(connectWalletResponse)));
            break;
        case WalletExtension.WALLETCONNECT:
            ({ err, res: wallet } = yield to(verifyWalletWC(connectWalletResponse)));
            break;
    }
    if (!wallet) {
        console.log("verifyWallet", err);
        throw err;
    }
    console.log("verifyWallet", walletProvider, connectWalletResponse, wallet);
    return wallet;
});
